import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {Avatar} from "@mui/material";
import {Link} from "react-router-dom";
import React from "react";
import makeStyles from '@mui/styles/makeStyles';

const useStylesAvatar = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
}));

const RouteAvatar = ({t, item, size = null, url = null, beforeRedirect = () => {}}) => {
    const classesAvatar = useStylesAvatar();
    let avatorProps = {};

    if (url !== null) {
        avatorProps.component = Link;
        avatorProps.to = url;
    }

    return <Avatar aria-label="recipe" className={item.avatarColor + " " + (size === "small" ? " " + classesAvatar.small : "")}
                   style={{textShadow: "1px 1px 1px #333",}}
                    {...avatorProps}
                   onClick={beforeRedirect}
    >
        {item?.types && item.types.length > 1 && <><span style={{
            position: 'relative',
            top: (size === "small" ? '-6px' : '-8px'),
            left: (size === "small" ? '6px' : '9px'),
            fontSize: (size === "small" ? "10px" : "14px")
        }}>{t('searchResults.avatar.cliff')}</span>
            {/*{size !== "small" && <br/>}*/}
            <span style={{
            position: 'relative',
            top: (size === "small" ? '4px' : '8px'),
            left: (size === "small" ? '-6px' : '-7px'),
            fontSize: (size === "small" ? "10px" : "14px")
        }}>
                    {t('searchResults.avatar.multipitch')}
                </span></>}
        {(item?.types.length === 1) && <span style={{
            fontSize: (size === "small" ? "11px" : "14px"),
        }}>{t('searchResults.avatar.' + item.types[0] )}</span>}


    </Avatar>
}

export default compose(
    withTranslation()
)(RouteAvatar);